import React from "react";
import VoucherGroupTotals from "./VoucherGroupTotals";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const VoucherGroupSummary = () => {
    const history = useHistory();

    const goToAddVoucherGroup = () => {
        history.push("/travel/vouchergroups/add");
    };

    return (
        <>
            <div>
                <Button onClick={goToAddVoucherGroup} variant="primary">Add Allowance Group</Button>
            </div>
            <div>
                <VoucherGroupTotals />                 
            </div>        
        </>
    );
}

export default VoucherGroupSummary;
